import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import { CloseSmallLinear } from "../../../icons";
import { ButtonBase } from "../../../internal/ButtonBase";
import { InputBase } from "../../../internal/InputBase";
import styles from './FIeld.css';
var cx = classNames.bind(styles);
export var Field = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var value = _ref.value,
      placeholder = _ref.placeholder,
      prepend = _ref.prepend,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      onChange = _ref.onChange,
      focused = _ref.focused,
      onBlur = _ref.onBlur;

  var handleChange = function handleChange(event) {
    onChange(event.target.value);
  };

  var handleClearValue = function handleClearValue(event) {
    event.stopPropagation();
    onChange(null);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: cx('root')
  }, prepend && prepend, /*#__PURE__*/React.createElement(InputBase, {
    ref: ref,
    className: cx('field'),
    value: value || '',
    placeholder: placeholder,
    disabled: disabled,
    onChange: handleChange,
    onBlur: onBlur
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('underline', {
      active: focused
    })
  }), value !== null && value !== void 0 && value.toString().length ? /*#__PURE__*/React.createElement(ButtonBase, {
    onClick: handleClearValue
  }, /*#__PURE__*/React.createElement(CloseSmallLinear, {
    color: "N300"
  })) : null);
});